// Swiper initializer
// Ensures any element with [data-swiper] gets a Swiper instance
// Uses the bundle build so modules (navigation, pagination) are included automatically
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

declare global {
    interface Window { Swiper: typeof Swiper }
}

// Extended HTMLElement with swiper initialization flag
interface SwiperElement extends HTMLElement {
    _swiperInitialized?: boolean;
}

window.Swiper = Swiper;

const initSwipers = () => {
    document.querySelectorAll<SwiperElement>('[data-swiper]')?.forEach(root => {
        if (root._swiperInitialized) return;
        const container = root.querySelector<HTMLElement>('.swiper');
        const pagination = root.querySelector<HTMLElement>('.swiper-pagination');
        const nextEl = root.querySelector<HTMLElement>('.swiper-button-next');
        const prevEl = root.querySelector<HTMLElement>('.swiper-button-prev');
        if (!container) return;

        new Swiper(container, {
            loop: false,
            slidesPerView: 1,
            spaceBetween: 16,
            pagination: pagination ? { el: pagination, clickable: true } : undefined,
            navigation: (nextEl && prevEl) ? { nextEl, prevEl } : undefined
        });
        root._swiperInitialized = true;
    });
};

// Init on DOM ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwipers);
} else {
    initSwipers();
}

// Support HMR
if (import.meta.hot) {
    import.meta.hot.accept(() => initSwipers());
}
